import React, { Component, Fragment } from 'react'
import BranchEditor from './../../modules/BranchEditor'
import BranchSelect from './../../modules/BranchSelect'
import injectStyles from 'react-jss'
import BranchFilesHOC from './../../modules/BranchFilesHOC'
import ControlBar from './../../modules/ControlBar'
import ArrowDown from './../../modules/ArrowDown'
import ReactDOM from 'react-dom'
import NewBranchDialog from './NewBranchDialog'
import Button from './../../modules/Button'
import SaveBranchDialog from './SaveBranchDialog'

const styles = {
  saveBox: {
    border: '1px solid blue',
    padding: 20,
  },
  currentBranchLabel: {
    width: 160,
    display: 'inline-block',
    textAlign: 'left',
  },
  branchSelect: {
    width: 377,
    height: 55,
    boxSizing: 'border-box',
    appearance: 'none',
    background: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAICAYAAAAiJnXPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADFSURBVHgBvVC9DgFBEJ4ZFAqJR/EmlDq5TntK1RZqWh06JZ3X8BQoJCQid27vWzM44fQmmc3M95PZGaJ/Bdszni7beZ61ADA8CPCaMCrAew5aKxKIsR0N45UYM+h318y0FZJAiohIsFQnWw+tqy+D6aUYean7TR6wN6POYDwMQtYI4UC386bQvk0uipKkgQVEBXhi9sUKy47S49w5l3zt9BmTyayZBurlwTd1l7OvXucujk8/hyiHU2MNWSeT2srF0anM3wHJ3miHhPddMAAAAABJRU5ErkJggg==)',
    backgroundPosition: 'right 15px center',
    backgroundRepeat: 'no-repeat',
    border: '1px solid #dee1e5',
    backgroundColor: 'white',
    borderRadius: 0,
    padding: '0 57px 0 22px',
  },
  newBranchButton: {
    paddingLeft: 38,
    paddingRight: 38,
    cursor: 'pointer',
  },
  saveBranchButton: {
    height: 36,
    lineHeight: 0,
    fontSize: 13,
    padding: '0px 20px',
    width: 72,
  },
}

class RepositoryEdit extends Component {

  state = {
    selectedSaveBranchId: this.props.branchIds[0],
  }

  onBranchSelect = (branchId) => {
    this.props.onBranchSelect(branchId)
    this.setState({
      selectedSaveBranchId: branchId,
    })
  }

  onSaveBranchSelect = (branchId) => this.setState({
    selectedSaveBranchId: branchId,
  })

  onNewBranchClick = () => this.setState({
    newBranchDialogOpen: true,
  })

  onSaveBranchClick = () => this.setState({
    saveBranchDialogOpen: true,
  })

  onNewBranchClose = () => this.setState({ newBranchDialogOpen: false, })

  onSaveBranchClose = () => this.setState({ saveBranchDialogOpen: false, })

  render = () => {
    const {
      branchIds,
      classes,
      selectedBranchId,
      thereAreUnsavedFilesOnTheSelectedBranch,
    } = this.props
    const {
      selectedSaveBranchId,
      newBranchDialogOpen,
      saveBranchDialogOpen,
    } = this.state

    return <Fragment>
      <ControlBar>
        <label className={classes.currentBranchLabel}>Current branch</label>
        <BranchSelect
          branchIds={branchIds}
          onChange={this.onBranchSelect}
          value={selectedBranchId}
          className={classes.branchSelect}
        />
        <span
          className={classes.newBranchButton}
          onClick={this.onNewBranchClick}
        >
          + New
        </span>
        {newBranchDialogOpen ?
          ReactDOM.createPortal(<NewBranchDialog
            repositoryId={this.props.repositoryId}
            onClose={this.onNewBranchClose}
            currentBranchId={selectedBranchId}
          />, document.body) :
          null}
        <Button
          className={classes.saveBranchButton}
          onClick={this.onSaveBranchClick}
          disabled={!thereAreUnsavedFilesOnTheSelectedBranch}
        >
          Save
        </Button>

        {saveBranchDialogOpen ?
          ReactDOM.createPortal(<SaveBranchDialog
            repositoryId={this.props.repositoryId}
            onClose={this.onSaveBranchClose}
          />, document.body) :
          null}
      </ControlBar>

      {selectedBranchId ?
        <BranchFilesHOC
          branchId={selectedBranchId}
          loadingElement={<p>Loading</p>}
        >
          <BranchEditor branchId={selectedBranchId} />
        </BranchFilesHOC> :
        null}
    </Fragment>
  }

}

export default injectStyles(styles)(RepositoryEdit)




// WEBPACK FOOTER //
// ./src/pages/RepositoryEdit/RepositoryEdit.js